@if (allowanceEntity$ | async) {
  <form [formGroup]="formGroup">
    <div formGroupName="aanvrager">
      <div class="row col-auto" style="--bs-gutter-x: 0.5rem;">
        <snelstart-ui-text-form-control class="custom-input-130"
                                        formControlName="voorletters"
                                        id="voorletters"
                                        label="Voorletter(s)"
        >
        </snelstart-ui-text-form-control>
        <snelstart-ui-text-form-control class="custom-input-125"
                                        formControlName="tussenvoegsels"
                                        id="tussenvoegsels"
                                        label="Tussenvoegsel"
        >
        </snelstart-ui-text-form-control>
      </div>
      <snelstart-ui-text-form-control [required]=true
                                      class="custom-input-250 "
                                      formControlName="achternaam"
                                      id="achternaam"
                                      label="Achternaam"
      >
      </snelstart-ui-text-form-control>
    </div>
    <snelstart-ui-bsn-form-control class="custom-input-250 "
                                   formControlName="bsn"
                                   id="bsn"
                                   label="Burgerservicenummer"
    >
    </snelstart-ui-bsn-form-control>
    <snelstart-ui-date-form-control class="custom-input-250"
                                    formControlName="geboortedatumAanvrager"
                                    id="geboortedatumAanvrager"
                                    label="Geboortedatum"
                                    placeholder="dd-mm-jjjj"
    >
    </snelstart-ui-date-form-control>
    <snelstart-ui-number-form-control [required]="true"
                                      [showAllDecimals]="false"
                                      align="right" class="custom-input-250" formControlName="toetsinkomenAangever"
                                      id="toetsinkomenAangever"
                                      label="Toetsinkomen {{ (allowanceEntity$ | async)?.year}}"
                                      prefix="€"
    >
    </snelstart-ui-number-form-control>
    <snelstart-ui-number-form-control [required]="true"
                                      [showAllDecimals]="false"
                                      align="right" class="custom-input-250"
                                      formControlName="toetsvermogenAangever"
                                      id="toetsvermogenAangever"
                                      label="Toetsvermogen {{ (allowanceEntity$ | async)?.year}}"
                                      prefix="€"
    >
    </snelstart-ui-number-form-control>
    <snelstart-ui-select-form-control [options]="optionsJaNee"
                                      class="custom-input-250"
                                      formControlName="aangeverHeeftZorgverzekering"
                                      id="aangeverHeeftZorgverzekering"
                                      label="Nederlandse zorgverzekering?"
    >
    </snelstart-ui-select-form-control>
  </form>
}

